const ReportsTab = () =>
  import(
    /* webpackChunkName: "ReportsTab" */ `@/components/rapsotec/projects/project/reports/ReportsTab.vue`
  );
const MailsTab = () =>
  import(
    /* webpackChunkName: "MailsTab" */ `@/components/rapsotec/projects/project/reports/MailsTab.vue`
  );
const SelectReportType = () =>
  import(
    /* webpackChunkName: "SelectReportType" */ `@/components/rapsotec/projects/project/reports/reportsTab/SelectReportType.vue`
  );
const AdditionalData = () =>
  import(
    /* webpackChunkName: "ReportAdditionalData" */ `@/components/rapsotec/projects/project/reports/reportsTab/AdditionalData.vue`
  );
const Contributors = () =>
  import(
    /* webpackChunkName: "Contributors" */ `@/components/rapsotec/projects/project/reports/reportsTab/Contributors.vue`
  );
const Recipients = () =>
  import(
    /* webpackChunkName: "ReportRecipients" */ `@/components/rapsotec/projects/project/reports/reportsTab/Recipients.vue`
  );
const CeaComment = () =>
  import(
    /* webpackChunkName: "CeaComment" */ `@/components/rapsotec/projects/project/reports/reportsTab/CeaComment.vue`
  );
const MailCreation = () =>
  import(
    /* webpackChunkName: "MailCreation" */ `@/components/rapsotec/projects/project/reports/reportsTab/MailCreation.vue`
  );
const ReportGenerationView = () =>
  import(
    /* webpackChunkName: "ReportGenerationView" */ `@/components/rapsotec/projects/project/reports/reportsTab/ReportGenerationView.vue`
  );
const ReportGenerationRapsotecView = () =>
  import(
    /* webpackChunkName: "ReportGenerationRapsotecView" */ `@/components/rapsotec/projects/project/reports/reportsTab/ReportGenerationRapsotecView.vue`
  );
const ReportGenerationRapsosecuView = () =>
  import(
    /* webpackChunkName: "ReportGenerationRapsosecuView" */ `@/components/rapsotec/projects/project/reports/reportsTab/ReportGenerationRapsosecuView.vue`
  );

const ReportGenerationRapsoitmView = () =>
  import(
    /* webpackChunkName: "ReportGenerationRapsoitmView" */ `@/components/rapsotec/projects/project/reports/reportsTab/ReportGenerationRapsoitmView.vue`
  );

const ReportGenerationRDReport = () =>
  import(
    /* webpackChunkName: "ReportGenerationRDReport" */ `@/components/rapsotec/projects/project/reports/reportsTab/ReportGenerationRDReport.vue`
  );
const MailGenerationView = () =>
  import(
    /* webpackChunkName: "MailGenerationView" */ `@/components/rapsotec/projects/project/reports/mailsTab/MailGenerationView.vue`
  );

export default [
  {
    path: "",
    name: "projectReports",
    component: ReportsTab,
  },
  {
    path: ":templateCode/select-report-type",
    name: "selectReportType",
    component: SelectReportType,
    props: true,
  },
  {
    path: ":templateCode/additional-data",
    name: "reportAdditionalData",
    component: AdditionalData,
    props: true,
  },
  {
    path: ":templateCode/contributors",
    name: "reportContributors",
    component: Contributors,
    props: true,
  },
  {
    path: ":templateCode/recipients",
    name: "reportRecipients",
    component: Recipients,
    props: true,
  },
  {
    path: ":templateCode/cea-comment",
    name: "ceaComment",
    component: CeaComment,
    props: true,
  },
  {
    path: ":templateCode/mail-creation",
    name: "mailCreation",
    component: MailCreation,
    props: true,
  },
  {
    path: ":templateCode/:finalAttestationType?/report-generation-morocco/:step",
    name: "reportGenerationView",
    component: ReportGenerationView,
    props: true,
  },
  {
    path: ":templateCode/report-generation/:step",
    name: "reportGenerationRapsotecView",
    component: ReportGenerationRapsotecView,
    props: true,
  },
  {
    path: ":templateCode/report-generation-secu/:step",
    name: "reportGenerationRapsosecuView",
    component: ReportGenerationRapsosecuView,
    props: true,
  },
  {
    path: ":templateCode/report-generation-itm/:step",
    name: "reportGenerationRapsoitmView",
    component: ReportGenerationRapsoitmView,
    props: true,
  },
  {
    path: ":templateCode/report-generation-rd/:step",
    name: "reportGenerationRDReport",
    component: ReportGenerationRDReport,
    props: true,
  },
  // Mail part
  {
    path: "mails",
    name: "projectMails",
    component: MailsTab,
  },
  {
    path: "mail-generation/:step",
    name: "mailGenerationView",
    component: MailGenerationView,
    props: true,
  },
];
